// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Wy","pending":"e_Xy","slider":"e_Yy","imageContainer":"e_Zy","image":"e__y","button":"e_0y","prevButton":"e_1y","nextButton":"e_2y","disabled":"e_3y"};